









































import Vue from 'vue';
import { ILimitingPosition } from '@/common/interfaces/limiting.interface';
import { IEventListener } from '@/common/interfaces/index.interface';
import config from '../../../../config';
import OldCartHelper from '../../../helpers/OldCartHelper';
import CookieHelper from '../../../helpers/OldCookieHelper';
import FetchHelper from '../../../helpers/OldFetchHelper';
import JWTHelper from '../../../helpers/JWTHelper';
import CustomButton from '../../layout/buttons/CustomButton.vue';
import LimitingPositionDisplay from '../LimitingPositionDisplay.vue';
import LimitingShoppingTimeDisplay from '../LimitingShoppingTimeDisplay.vue';
import DomEventHelper from '../../../helpers/DomEventHelper';
import DomPositioningHelper from '../../../helpers/DomPositioningHelper';
import EventListenerHelper from '../../../helpers/EventListenerHelper';

interface INotificationBarComponent {
  addToCartRetryPayload: { amount: number; cartId: number; matchcode: string } | null;
  areaId: string;
  areaTopPosition: number;
  body: HTMLBodyElement | null;
  dispatchActivationEvent: boolean;
  exclusiveShoppingUrl: string;
  limitingActive: boolean;
  loading: boolean;
  minimalMode: boolean;
  mountedDocumentEventListeners: IEventListener[];
  mountedWindowEventListeners: IEventListener[];
  position: ILimitingPosition;
  showNotificationBar: boolean;
  webSocket: WebSocket | null;
  webSocketEvents: IEventListener[];
}

export default Vue.extend({
  name: `LimitingNotificationBar`,
  components: {
    CustomButton,
    LimitingPositionDisplay,
    LimitingShoppingTimeDisplay,
  },
  data(): INotificationBarComponent {
    return {
      addToCartRetryPayload: null,
      areaId: `limitingNotificationBar`,
      areaTopPosition: 0,
      body: document.querySelector(`body`),
      dispatchActivationEvent: false,
      exclusiveShoppingUrl: config.wpUrls.exclusiveShopping,
      limitingActive: false,
      loading: true,
      minimalMode: false,
      mountedDocumentEventListeners: [],
      mountedWindowEventListeners: [],
      position: {
        current: 0,
        list: `ll`,
        total: 0,
      },
      showNotificationBar: false,
      webSocket: null,
      webSocketEvents: [
      ],
    };
  },
  created(): void {
    this.mountedDocumentEventListeners = [
      { callback: this.activateLimiting, name: `rin-limiting-active` },
      { callback: this.closeExistingShoppingConnection, name: `rin-limiting-not-active` },
      { callback: this.handleLimitingRequestWithDeactivatedBouncer, name: `rin-limiting-request-with-deactivated-bouncer` },
      { callback: this.checkoutCompleted, name: `rin-limiting-checkout-completed` },
      { callback: this.storeAddToCartToRetry, name: `rin-limiting-add2cart-retry` },
    ];
    this.mountedWindowEventListeners = [
      { callback: this.fireDispatchActivationEvent, name: `DOMContentLoaded` },
      { callback: this.resizeListeners, name: `resize` },
      { callback: this.updateDisplayMode, name: `scroll` },
    ];
    this.webSocketEvents = [
      { callback: this.handleWebSocketMessage, name: `message` },
      { callback: this.handleWebSocketOpenEvent, name: `open` },
    ];
  },
  async mounted(): Promise<void> {
    EventListenerHelper.setUpEventListeners(this.mountedDocumentEventListeners);
    if((CookieHelper.getBouncerShoppingJWT() || CookieHelper.getBouncerWebSocketConnectionJWT())) {
      if(this.checkCookieValidity()) {
        this.dispatchActivationEvent = true;
        await this.activateLimiting();
      }
    }
  },
  beforeDestroy(): void {
    this.removeEventListeners();
    this.cleanUpWebSocketConnection();
  },
  methods: {
    async activateLimiting(): Promise<void> {
      if(await this.isBouncerActive()) {
        this.limitingActive = true;
        this.showNotificationBar = true;
        await this.setUp();
      } else {
        this.cleanUpEverything();
        DomEventHelper.fireEvent({ name: `rin-limiting-request-with-deactivated-bouncer` });
      }
    },
    async allowShopping(jwt: string, instantShopping = false): Promise<void> {
      CookieHelper.removeBouncerWebSocketConnectionJWT();
      CookieHelper.setBouncerShoppingJWT(jwt);
      if(!CookieHelper.getBouncerShoppingStartTime()) {
        CookieHelper.setBouncerShoppingStartTime(Date.now());
      }

      if(instantShopping && this.addToCartRetryPayload) {
        await OldCartHelper.addItemToCart(
          { amount: this.addToCartRetryPayload.amount, matchcode: this.addToCartRetryPayload.matchcode },
          this.addToCartRetryPayload.cartId,
          config.cartTypes.EIGENBEDARF,
        );
        this.addToCartRetryPayload = null;
      }
      this.createWebSocketConnection();
      this.position.list = `cl`;
      this.$nextTick(this.setLimitingBodyMarginTop);

      DomEventHelper.fireEvent({ detail: this.position, name: `rin-limiting-position-update` });
      DomEventHelper.fireEvent({ name: `rin-limiting-shopping-allowed` });
    },
    checkCookieValidity(): boolean {
      const bouncerShoppingJWT = CookieHelper.getBouncerShoppingJWT();
      if(bouncerShoppingJWT) {
        const decodedBouncerShoppingJWT = JWTHelper.parseJwt(bouncerShoppingJWT);
        if(decodedBouncerShoppingJWT.exp * 1000 > Date.now()) {
          return true;
        }
      }
      const bouncerWebSocketJWT = CookieHelper.getBouncerWebSocketConnectionJWT();
      if(bouncerWebSocketJWT) {
        const decodedBouncerWebSocketJWT = JWTHelper.parseJwt(bouncerWebSocketJWT);
        if(decodedBouncerWebSocketJWT.exp * 1000 > Date.now()) {
          return true;
        }
      }
      this.cleanUpEverything();
      return false;
    },
    async checkoutCompleted(): Promise<void> {
      const fetchConfig = {
        baseURL: config.bouncer.api.baseurl,
        body: { id: CookieHelper.getBouncerShoppingJWT() },
        path: config.bouncer.api.paths.finish,
      };
      await FetchHelper.post(fetchConfig);
      this.cleanUpEverything(true);
    },
    cleanUpEverything(checkoutComplete = false): void {
      CookieHelper.removeBouncerShoppingJWT();
      CookieHelper.removeBouncerShoppingStartTime();
      CookieHelper.removeBouncerWebSocketConnectionJWT();
      this.removeLimitingBodyClass();
      DomPositioningHelper.registerArea(1, this.areaId, 0);
      if(this.webSocket) {
        this.webSocket.close();
        EventListenerHelper.teardownEventListeners(this.webSocketEvents, this.webSocket);
        this.webSocket = null;
      }
      this.position = {
        current: -1,
        list: `ll`,
        total: 0,
      };
      DomEventHelper.fireEvent({ detail: this.position, name: `rin-limiting-position-update` });
      if(checkoutComplete) {
        DomEventHelper.fireEvent({ name: `rin-limiting-finish-order` });
      }
    },
    cleanUpWebSocketConnection(): void {
      if(this.webSocket) {
        EventListenerHelper.teardownEventListeners(this.webSocketEvents, this.webSocket);
        this.webSocket.close();
        this.webSocket = null;
      }
    },
    closeExistingShoppingConnection(showSwal = true): void {
      this.cleanUpEverything();
      this.showNotificationBar = false;
      if(showSwal) {
        this.$swal(``, this.$t(`limiting:general.timeIsUp`), `info`);
      }
    },
    createWebSocketConnection(): void {
      if(this.webSocket) {
        return;
      }

      const webSocketJWT = CookieHelper.getBouncerWebSocketConnectionJWT() || CookieHelper.getBouncerShoppingJWT();
      this.webSocket = new WebSocket(`${config.bouncer.ws.baseurl}?id=${webSocketJWT}`);
      EventListenerHelper.setUpEventListeners(this.webSocketEvents, this.webSocket);
    },
    fireDispatchActivationEvent(): void {
      if(this.dispatchActivationEvent) {
        DomEventHelper.fireEvent({ name: `rin-limiting-still-active` });
        this.dispatchActivationEvent = false;
      }
    },
    async getInformationFromBouncer(): Promise<void> {
      if(!CookieHelper.getCookie(`ccn-interacted`)) {
        window.setTimeout(() => {
          this.getInformationFromBouncer();
        }, 1000);
        return;
      }
      await this.requestAccessFromBouncer();
      const shoppingToken = CookieHelper.getBouncerShoppingJWT();
      if(shoppingToken) {
        this.createWebSocketConnection();
        await this.allowShopping(shoppingToken);
      } else {
        await this.getListStatus();
      }
    },
    async getListStatus(): Promise<void> {
      const userToken = JWTHelper.parseJwt(CookieHelper.getBouncerWebSocketConnectionJWT());
      if(!userToken) {
        this.getInformationFromBouncer();
        return;
      }
      // token expired
      if(userToken.exp < Date.now() / 1000) {
        CookieHelper.removeBouncerWebSocketConnectionJWT();
        await this.requestAccessFromBouncer();
        return;
      }
      const userId = userToken.id;
      const fetchConfig = {
        baseURL: config.bouncer.api.baseurl,
        ignoreCredentials: true,
        path: config.bouncer.api.paths.status,
      };
      const fetchResult = await FetchHelper.get(fetchConfig);
      this.$loggingService.log({ sessionStack: true }, JSON.stringify(fetchResult));

      let firstQueuePosition = fetchResult.firstShortlistId;
      if(firstQueuePosition === 0) {
        firstQueuePosition = fetchResult.longlistCursorStartPosition;
      }
      if(fetchResult.success) {
        this.position.current = userId - firstQueuePosition + 1;
        this.position.list = userId <= fetchResult.lastShortlistId ? `sl` : `ll`;
        DomEventHelper.fireEvent({ detail: this.position, name: `rin-limiting-position-update` });

        if(userId < fetchResult.longlistCursorStartPosition) {
          this.createWebSocketConnection();
        } else {
          window.setTimeout(async () => {
            await this.getListStatus();
          }, 15000);
        }
      }
    },
    goToInformationPage(): void {
      window.location.href = config.wpUrls.exclusiveShopping;
    },
    handleLimitingRequestWithDeactivatedBouncer(): void {
      this.closeExistingShoppingConnection(false);
    },
    handlePositionChange(): void {
      if(this.body) {
        DomPositioningHelper.setBodyPosition(this.body);
      }
      this.areaTopPosition = DomPositioningHelper.getAreaTopPosition(`limitingNotificationBar`);
    },
    async handleWebSocketMessage(event: MessageEvent): Promise<void> {
      const data: { jwt?: string; position?: number; success: boolean } = JSON.parse(event.data);
      if(!data.success) {
        this.webSocket?.close();
        CookieHelper.removeBouncerWebSocketConnectionJWT();
        await this.requestAccessFromBouncer();
      }
      if(data.position) {
        if(this.position.current !== data.position) {
          this.$loggingService.log({ sessionStack: true }, event.data);
        }
        this.position.current = data.position;
      }
      if(data.jwt) {
        this.$loggingService.log({ sessionStack: true }, event.data);
        await this.allowShopping(data.jwt);
      }
    },
    handleWebSocketOpenEvent(): void {
      const waitingToken = CookieHelper.getBouncerWebSocketConnectionJWT();
      if(waitingToken) {
        this.webSocket?.send(JSON.stringify({ id: waitingToken }));
      }
    },
    async isBouncerActive(): Promise<boolean> {
      const bouncerData = await FetchHelper.get({ path: `${config.api.paths.configs.basepath}${config.api.paths.configs.paths.bouncer}` });
      return bouncerData.data.active;
    },
    removeEventListeners(): void {
      EventListenerHelper.teardownEventListeners(this.mountedDocumentEventListeners);
      EventListenerHelper.teardownEventListeners(this.mountedWindowEventListeners, window);
      EventListenerHelper.teardownEventListeners([{ callback: this.handlePositionChange, name: `rin-top-margin-height-changed` }]);
    },
    removeLimitingBodyClass(): void {
      this.body?.classList.remove(`rin-limiting-active`);
    },
    async requestAccessFromBouncer(): Promise<void> {
      if(CookieHelper.getBouncerWebSocketConnectionJWT() || CookieHelper.getBouncerShoppingJWT()) {
        return;
      }

      const fetchConfig = {
        baseURL: config.bouncer.api.baseurl,
        ignoreCredentials: true,
        path: config.bouncer.api.paths.newUser,
      };

      const fetchResult = await FetchHelper.post(fetchConfig);
      this.$loggingService.log({ sessionStack: true }, JSON.stringify(fetchResult));
      if(fetchResult.success) {
        if(fetchResult.type === `jwt`) {
          await this.allowShopping(fetchResult.jwt, true);
        }
        if(fetchResult.type === `queue`) {
          this.addToCartRetryPayload = null;
          const jwt = fetchResult.id;
          CookieHelper.setBouncerWebSocketConnectionJWT(jwt);
        }
      }
    },
    resizeListeners(): void {
      window._.debounce(() => {
        this.setLimitingBodyMarginTop();
        this.updateDisplayMode();
      }, 250);
    },
    setEventListeners(): void {
      EventListenerHelper.setUpEventListeners(this.mountedWindowEventListeners, window);
      EventListenerHelper.setUpEventListeners([{ callback: this.closeExistingShoppingConnection, name: `rin-limiting-time-is-up` }]);
      EventListenerHelper.setUpEventListeners([{ callback: this.handlePositionChange, name: `rin-top-margin-height-changed` }]);
    },
    setLimitingBodyClass(): void {
      this.body?.classList.add(`rin-limiting-active`);
    },
    setLimitingBodyMarginTop(): void {
      if(!this.$refs.limitingNotificationBar) {
        return;
      }
      const height = (this.$refs.limitingNotificationBar as HTMLDivElement).clientHeight;
      DomPositioningHelper.registerArea(1, this.areaId, height);
    },
    async setUp(): Promise<void> {
      if(this.limitingActive) {
        this.setLimitingBodyClass();
        this.setEventListeners();
        await this.getInformationFromBouncer();
        this.loading = false;
        this.$nextTick(this.setLimitingBodyMarginTop);
      }
    },
    storeAddToCartToRetry(event: { detail: { amount: number; cartId: number; matchcode: string } }): void {
      this.addToCartRetryPayload = event.detail;
    },
    updateDisplayMode(): void {
      if(!this.$refs.limitingNotificationBar) {
        return;
      }
      const notificationBar = this.$refs.limitingNotificationBar as HTMLDivElement;
      // 720px is the breakpoint where the notification bar switches to desktop mode
      if(window.innerWidth <= 720) {
        const scrollPosition = document.documentElement.scrollTop || document.body.scrollTop;
        const headerHeight = document.querySelector(`div.header-mobile`)?.clientHeight ?? 0;
        if(scrollPosition >= headerHeight && !notificationBar.classList.contains(`limiting-notification-bar--minimal`)) {
          this.minimalMode = true;
          this.updateHeightOnScroll();
        } else if(scrollPosition < headerHeight && notificationBar.classList.contains(`limiting-notification-bar--minimal`)) {
          this.minimalMode = false;
          this.updateHeightOnScroll();
        }
      } else if(this.minimalMode) {
        this.minimalMode = false;
        this.updateHeightOnScroll();
      }
    },
    updateHeightOnScroll(): void {
      setTimeout(() => {
        const height = (this.$refs.limitingNotificationBar as HTMLDivElement).clientHeight;
        DomPositioningHelper.registerArea(1, this.areaId, height);
      }, 125);
    },
  },
});
